// extracted by mini-css-extract-plugin
export default {"header":"home_header__XfPhr","headerText":"home_headerText__vq4fB","navheader":"home_navheader__y5dCj"};